import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, PRINCIPLES } from "../mock";
import { CtaBanner } from "./Home";

export default function About() {
  return (
    <main>
      <section className="pt-[140px] pb-16 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] text-[#1A1D14]/60 mb-6">
            <span className="inline-block w-1.5 h-1.5 bg-[#B29774]" />
            <span>ABOUT</span>
            <span className="w-10 h-px bg-[#1A1D14]/30" />
            <span>MOHAN LTD</span>
          </div>
          <h1 className="font-display text-[56px] md:text-[96px] leading-[0.95] font-medium tracking-[-0.03em]">
            A UK construction<br />company built<br /><span className="text-[#1A1D14]/40">around detail.</span>
          </h1>
        </div>
      </section>

      <section className="pb-24 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16">
          <img src={IMAGES.intro} alt="About Mohan Ltd" className="w-full h-[560px] object-cover" />
          <div>
            <h2 className="font-display text-[36px] md:text-[48px] leading-[1.05] font-medium tracking-[-0.02em]">Our story.</h2>
            <p className="mt-6 text-[#1A1D14]/70 leading-relaxed">
              Mohan Ltd is a UK construction and building development company. We work on residential, commercial and specialised construction projects, combining practical planning with strong on-site execution.
            </p>
            <p className="mt-4 text-[#1A1D14]/70 leading-relaxed">
              Our team focuses on the details that make a project work — clear briefs, structured programmes, careful workmanship and honest communication throughout every stage of construction.
            </p>
            <div className="mt-10 grid grid-cols-2 gap-6">
              <div>
                <div className="font-display text-4xl font-medium">10+</div>
                <div className="text-sm text-[#1A1D14]/60 mt-2">Years of construction experience</div>
              </div>
              <div>
                <div className="font-display text-4xl font-medium">UK</div>
                <div className="text-sm text-[#1A1D14]/60 mt-2">Nationwide project delivery</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#EFECE4]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.05] font-medium tracking-[-0.02em]">Our principles.</h2>
          <div className="mt-12 border-t border-[#1A1D14]/15">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
              {PRINCIPLES.map((p) => (
                <div key={p.num} className="border-b lg:border-b-0 lg:border-r border-[#1A1D14]/15 last:border-r-0 p-8">
                  <span className="text-[#1A1D14]/50 text-sm">{p.num}</span>
                  <h3 className="mt-14 font-display text-[24px] font-medium">{p.title}</h3>
                  <p className="mt-4 text-[#1A1D14]/70 text-sm leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CtaBanner />
    </main>
  );
}
